import $ from 'jquery'
import React from 'react'
import Text from 'react-text'
import Icon from '../../icon'
import loadMoxie from '../../../helpers/moxie'
import {Consumer} from '../../../context'
import {saveUpload} from '../../../context/post'

import './upload.styl'

function createSelect({action, label, options, onChange}) {
  const $container = $('<div>',{class: `select_${action}`})
  $('<label>', {text: label}).appendTo($container)
  const $select = $('<select>').appendTo($container)
  $('<option>',{text: '', value: '', selected: 'selected'}).appendTo($select)
  options.forEach(item => {
    $('<option>', {text: item.name, value:item.id}).appendTo($select)
  })
  $select.on('change', (e) => {
    $("option[value='']", e.target).remove()
    onChange({[action]: $(e.target).val()})
  })
  return $select
}

function enableUpload (enable) {
  const $button = $('.moxman-primary > button')
  if (enable) {
    $button.removeAttr('disabled').parent().removeClass('disabled')
  }
  else {
    $button.attr('disabled','disabled').parent().addClass('disabled')
  }
}

function createSelectGrade (container, label, options, context) {
  $('.select_grade', container).remove()
  enableUpload(false)
  const $grades = createSelect({
    action: 'grade',
    label,
    options,
    onChange: ({grade}) => {
      enableUpload(true)
      context.grade = grade
    }
  })
  container.append($grades.parent())
}

function createSelectSubject (container, label, options, context) {
  const  $subjects = createSelect({
    action: 'subject',
    label,
    options,
    onChange: ({subject}) => {
      context.subject = subject
      const grades = Object.values(context.subjects[subject].grades)
      createSelectGrade(container, context.translate('grade_label'), grades, context)
    }
  })
  container.append($subjects.parent())
}

async function showUpload({locale, subjects, translate, profile, setState, uploadUpdates}) {
  const context = {subjects, translate}
  const $uploadInfo = $('<div>', {"class": 'uploadInfo'})
  createSelectSubject(
    $uploadInfo,
    translate('subject_label'),
    Object.values(subjects),
    context
  )
  createSelectGrade(
    $uploadInfo,
    translate('grade_label'),
    [],
    context
  )
  await loadMoxie
  $('body').on('DOMSubtreeModified','.moxman-window', () => {
    $('body').off('DOMSubtreeModified','.moxman-window')
    $('.moxman-window .moxman-upload-drop-zone').parent().prepend($uploadInfo)
    enableUpload(false)
  })

  window.moxman.upload({
    path: '/lesson',
    onupload: (e) => {
      Promise
        .all(e.files
          .map(file => ({
            name: file.name,
            subject: context.subject,
            grade: context.grade, 
            file: `${profile.domain}/${profile.Passport.userName}/lesson/${file.name}`}))
          .map(saveUpload))
        .then(() => {
          setState({uploadUpdates: uploadUpdates + 1})
          $('.moxman-last > button').trigger('click')
        })
    }
  })
}


export default function UploadLesson(props) {
  return (<Consumer>{ context => {
    const {languageId, settings, translate, profile, uploadUpdates, setState} = context
    const locale = settings.moxman[languageId]
    const subjects = context.groups.reduce((acc, group) => {
      const subjectId = group.course.substring(0,2)
      const gradeId = group.course.substring(4,7)
      acc[subjectId] = acc[subjectId] || {id: subjectId, name: group.subject, grades: {}}
      acc[subjectId].grades[gradeId] = acc[subjectId].grades[gradeId] || {id: gradeId, name: group.grade}
      return acc
    }, {})
    return (
      <div className="upload-lesson" onClick={() => showUpload({locale, subjects, translate, profile, uploadUpdates, setState})}>
        <div className="icon-wrapper">
          <Icon name="lesson-upload" />
        </div>
        <div className="label-wrapper">
          <Text id="upload_lesson_label" />
        </div>
      </div>
    )
 }}</Consumer>)
}
